/* eslint-disable */
import { RINGS_TYPE } from '@ringcentral-integration/commons/modules/RingtoneConfiguration/const';
export default {
  [RINGS_TYPE.Phone_Ring1]: 'Toque do telefone 1',
  [RINGS_TYPE.Phone_Ring2]: 'Toque do telefone 2',
  [RINGS_TYPE.Acoustic_Dreams]: 'Sonhos acústicos',
  [RINGS_TYPE.Air_Raid]: 'Ataque aéreo',
  [RINGS_TYPE.Allusive]: 'Alusivo',
  [RINGS_TYPE.Attention]: 'Atenção',
  [RINGS_TYPE.Blub_Blub]: 'Blub Blub',
  [RINGS_TYPE.Buzzy]: 'Zumbido',
  [RINGS_TYPE.Channel_Open]: 'Canal aberto',
  [RINGS_TYPE.Contemplation]: 'Contemplação',
  [RINGS_TYPE.Crystal_Ball]: 'Bola de cristal',
  [RINGS_TYPE.Disco]: 'Discoteca',
  [RINGS_TYPE.Door_Bell]: 'Campainha de porta',
  [RINGS_TYPE.Fairy]: 'Fada',
  [RINGS_TYPE.Fast_Bells]: 'Sinos rápidos',
  [RINGS_TYPE.High_Gong]: 'Gongo alto',
  [RINGS_TYPE.Immersion]: 'Imersão',
  [RINGS_TYPE.Indeed]: 'Realmente',
  [RINGS_TYPE.Lazy_Day]: 'Dia de preguiça',
  [RINGS_TYPE.Neural_Funk]: 'Funk neural',
  [RINGS_TYPE.Nice]: 'Agradável',
  [RINGS_TYPE.Ring]: 'Campainha',
  [RINGS_TYPE.Ringing_Bells]: 'Sinos a tocar',
  [RINGS_TYPE.Simple]: 'Simples',
  [RINGS_TYPE.Soothing]: 'Calmante',
  [RINGS_TYPE.Sunshine]: 'Luz do sol',
  [RINGS_TYPE.Off]: 'Desativado',
  add: 'Adicionar',
  delete: 'Eliminar',
  play: 'Reproduzir',
  cancel: 'Cancelar',
  confirmToDelete: 'Eliminar {name}?',
} as const;

// @key: @#@"[RINGS_TYPE.Phone_Ring1]"@#@ @source: @#@"Phone Ring 1"@#@
// @key: @#@"[RINGS_TYPE.Phone_Ring2]"@#@ @source: @#@"Phone Ring 2"@#@
// @key: @#@"[RINGS_TYPE.Acoustic_Dreams]"@#@ @source: @#@"Acoustic Dreams"@#@
// @key: @#@"[RINGS_TYPE.Air_Raid]"@#@ @source: @#@"Air Raid"@#@
// @key: @#@"[RINGS_TYPE.Allusive]"@#@ @source: @#@"Allusive"@#@
// @key: @#@"[RINGS_TYPE.Attention]"@#@ @source: @#@"Attention"@#@
// @key: @#@"[RINGS_TYPE.Blub_Blub]"@#@ @source: @#@"Blub Blub"@#@
// @key: @#@"[RINGS_TYPE.Buzzy]"@#@ @source: @#@"Buzzy"@#@
// @key: @#@"[RINGS_TYPE.Channel_Open]"@#@ @source: @#@"Channel Open"@#@
// @key: @#@"[RINGS_TYPE.Contemplation]"@#@ @source: @#@"Contemplation"@#@
// @key: @#@"[RINGS_TYPE.Crystal_Ball]"@#@ @source: @#@"Crystal Ball"@#@
// @key: @#@"[RINGS_TYPE.Disco]"@#@ @source: @#@"Disco"@#@
// @key: @#@"[RINGS_TYPE.Door_Bell]"@#@ @source: @#@"Door Bell"@#@
// @key: @#@"[RINGS_TYPE.Fairy]"@#@ @source: @#@"Fairy"@#@
// @key: @#@"[RINGS_TYPE.Fast_Bells]"@#@ @source: @#@"Fast Bells"@#@
// @key: @#@"[RINGS_TYPE.High_Gong]"@#@ @source: @#@"High Gong"@#@
// @key: @#@"[RINGS_TYPE.Immersion]"@#@ @source: @#@"Immersion"@#@
// @key: @#@"[RINGS_TYPE.Indeed]"@#@ @source: @#@"Indeed"@#@
// @key: @#@"[RINGS_TYPE.Lazy_Day]"@#@ @source: @#@"Lazy Day"@#@
// @key: @#@"[RINGS_TYPE.Neural_Funk]"@#@ @source: @#@"Neural Funk"@#@
// @key: @#@"[RINGS_TYPE.Nice]"@#@ @source: @#@"Nice"@#@
// @key: @#@"[RINGS_TYPE.Ring]"@#@ @source: @#@"Ring"@#@
// @key: @#@"[RINGS_TYPE.Ringing_Bells]"@#@ @source: @#@"Ringing Bells"@#@
// @key: @#@"[RINGS_TYPE.Simple]"@#@ @source: @#@"Simple"@#@
// @key: @#@"[RINGS_TYPE.Soothing]"@#@ @source: @#@"Soothing"@#@
// @key: @#@"[RINGS_TYPE.Sunshine]"@#@ @source: @#@"Sunshine"@#@
// @key: @#@"[RINGS_TYPE.Off]"@#@ @source: @#@"Off"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"delete"@#@ @source: @#@"Delete"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirmToDelete"@#@ @source: @#@"Delete {name}?"@#@
